module.exports = __webpack_public_path__ + "img/icon_sportMenu_volleyball.5fb616e5.svg";